import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { HttpModule } from '@angular/http';
import { routing, appRoutingProviders } from './app.routing';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { LoginService } from './services/login.service';
import { LoginComponent } from './components/login/login.component';
import { CommonService } from './services/common.service';
import { HeaderComponent } from './components/header/header.component';
import { PassengersReportComponent } from './components/passengers-report/passengers-report.component';
import { PassengersReportService } from './services/passengers-report.service';
import { AlertService } from './services/alert.service' ;
import { MasterComponent } from './components/master/master.component';
import { AuthGuard } from './guards/guards.component';
import { MenuComponent } from './menu/menu.component';
import { RouteComponent } from './components/route/route.component';
import { RoutesComponent } from './components/routes/routes.component';
import { RoutesService } from './services/routes.service';
import { RouteService } from './services/route.service';
import { RateService } from './services/rate.service';
import { PointsService } from './services/points.service';
import { AlertComponent } from './components/alert/alert.component';
import { DriversComponent } from './components/drivers/drivers.component';
import { DriverComponent } from './components/driver/driver.component';
import { DriversService } from './services/drivers.service';
import { DriverService } from './services/driver.service';
import { ExcelService } from './services/excel.service';
import { PointsComponent } from './components/points/points.component';
import { RateComponent } from './components/rate/rate.component';
import { CompanyComponent } from './components/company/company.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { CompaniesService } from './services/companies.service';
import { RoutetraceComponent } from './components/routetrace/routetrace.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConsolidatedByPlateComponent } from './components/consolidated-by-plate/consolidated-by-plate.component';
import { ConsolidatedByPlateService} from './services/consolidated-by-plate.service';
import { SettlementComponent } from './components/settlement/settlement.component';
import { SettlementService } from './services/settlement.service';
import { ScriptLoaderService } from './services/script-loader.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DashboardService } from './services/dashboard.service';
import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';
import { TimeReportComponent } from './components/time-report/time-report.component';
import { ControlpointsComponent } from './components/controlpoints/controlpoints.component';
import { ControlpointComponent } from './components/controlpoint/controlpoint.component';
import { TransmissionVehiclesComponent } from './components/transmission-vehicles/transmission-vehicles.component';
import { VehiclesServiceService } from './services/vehicles-service.service';
import { HolidayCalendarComponent } from './components/holiday-calendar/holiday-calendar.component';
import { HolidayCalendarService } from './services/holiday-calendar.service';
import { UserComponent } from './components/user/user.component';
import { UsersComponent } from './components/users/users.component';
import { UsersService } from './services/users.services';
import { UserService } from './services/user.service';
import { AlertReportComponent } from './components/alert-report/alert-report.component';
import { Alertreportservice} from './services/alertreport.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AlarmUbicationComponent } from './components/alarm-ubication/alarm-ubication.component';
//import { DataTablesModule } from 'angular-datatables'
import * as $ from 'jquery';
// import 'datatables.net';
// import 'datatables.net-bs4';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
  MatSortModule, MatTableModule } from '@angular/material';
import { RouteDisplayComponent } from './components/route-display/route-display.component';
import { PicoTimesComponent } from './components/pico-times/pico-times.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { DispatcherreportComponent } from './components/dispatcherreport/dispatcherreport.component';
import { DriverReportComponent } from './components/driver-report/driver-report.component';
import { TimereportconsolidateComponent } from './components/timereportconsolidate/timereportconsolidate.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    PassengersReportComponent,
    MasterComponent,
    MenuComponent,
    RouteComponent,
    RoutesComponent,
    AlertComponent,
    DriversComponent,
    DriverComponent,
    PointsComponent,
    CompanyComponent,
    CompaniesComponent,
    RoutetraceComponent,
    RateComponent,
    ConsolidatedByPlateComponent,
    SettlementComponent,
    DashboardComponent,
    TimeReportComponent,
    ControlpointsComponent,
    ControlpointComponent,
    TransmissionVehiclesComponent,
    HolidayCalendarComponent,
    UserComponent,
    UsersComponent,
    AlertReportComponent,
    AlarmUbicationComponent,
    RouteDisplayComponent,
    PicoTimesComponent,
    DispatcherreportComponent,
    DriverReportComponent,
    TimereportconsolidateComponent,

  ],
  imports: [
    BrowserModule,
    FormsModule,
    routing,
    HttpClientModule,
    NgxSpinnerModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpModule,
    NgSelectModule,
    NgbModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    NgxMaterialTimepickerModule.forRoot()
  ],
  providers: [
    appRoutingProviders,
    LoginService,
    CommonService,
    AuthGuard,
    PassengersReportService,
    Alertreportservice,
    AlertService,
    RoutesService,
    RouteService,
    RateService,
    NgbActiveModal,
    DriversService,
    PointsService,
    DriverService,
    ExcelService,
    CompaniesService,
    NgxSpinnerService,
    ConsolidatedByPlateService,
    SettlementService,
    ScriptLoaderService,
    DashboardService,
    VehiclesServiceService,
    HolidayCalendarService,
    UsersService,
    UserService,
    { provide: NG_SELECT_DEFAULT_CONFIG,
      useValue: {
        notFoundText: 'No se encontraron resultados.'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/app.module.ts